import { CountryCode } from "@krea/shared/types/common";

export const countryCodeToName: Record<CountryCode, string> = {
  [CountryCode.SE]: "Sweden",
  [CountryCode.FI]: "Finland",
};
